// Layout.jsx
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

const Layout = () => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Determine the search placeholder based on the route
  const getSearchPlaceholder = () => {
    switch (location.pathname) {
      case "/users":
        return "Search Users Here";
      case `/users/${location.pathname.split("/")[2]}`:
        return "Search Users Here";
      case "/vendors":
        return "Search Vendors Here";
      case `/vendors/${location.pathname.split("/")[2]}`:
        return "Search Vendors Here";
      case "/Category":
        return "Search Category Here";
        case "/orders":
          return "Search Orders Here";      
          case "/notifications":
          return "Search notifications Here";
          case "/vendors-payout":
            return "Search vendors payout Here";
      default:
        return "Search anything here";
    }
  };

  return (
    <div className="min-h-screen flex bg-primary">
      <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
      
      {/* Hamburger menu button - only visible when sidebar is closed */}
      {!isSidebarOpen && (
        <button
          onClick={toggleSidebar}
          className="fixed top-4 left-4 z-50 bg-secondary hover:bg-accent-dark text-white p-3 rounded-lg transition-colors duration-200 flex items-center"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      )}
      
      <main className={`flex-1 transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-0'}`} style={{
        marginLeft: isSidebarOpen ? '256px' : '0px',
        transition: 'margin-left 0.3s ease-in-out'
      }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
